/*
 * Sportsact: cookie-banner på Shopifys Customer Privacy API (sections/custom-cookie-banner.liquid).
 * Samtykke registreres KUN ved klik. Ingen kategorier er slået til på forhånd.
 */
class CustomCookieBanner extends HTMLElement {
  #api = null;

  connectedCallback() {
    this.banner = this.querySelector('.custom-cookie__banner');
    this.dialog = this.querySelector('.custom-cookie__dialog');

    this.addEventListener('click', this.#onClick.bind(this));

    // "Cookie-indstillinger" i footeren (eller ethvert link til #cookie-indstillinger)
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cookie-settings], a[href$="#cookie-indstillinger"]');

      if (trigger) {
        event.preventDefault();
        this.openDialog();
      }
    });

    this.#trackStickyBarHeight();

    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) {
        return;
      }

      this.#api = window.Shopify.customerPrivacy;

      // shouldShowBanner() siger kun, at samtykke kræves – vis kun, hvis der ikke allerede er truffet et valg
      const consent = this.#api?.currentVisitorConsent?.() || {};
      const hasChosen = ['analytics', 'marketing', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');

      if (this.#api?.shouldShowBanner() && !hasChosen && !this.hasAttribute('data-design-mode')) {
        this.banner.hidden = false;
      }
    });

    // I Theme Editor: vis banneret, når sektionen er valgt
    if (this.hasAttribute('data-design-mode')) {
      const section = this.closest('.shopify-section');
      section?.addEventListener('shopify:section:select', () => (this.banner.hidden = false));
      section?.addEventListener('shopify:section:deselect', () => (this.banner.hidden = true));
    }
  }

  openDialog() {
    const consent = this.#api?.currentVisitorConsent?.() || {};

    this.dialog.querySelectorAll('.custom-cookie__switch').forEach((input) => {
      input.checked = consent[input.name] === 'yes';
    });

    if (!this.dialog.open) {
      this.dialog.showModal();
    }
  }

  #onClick(event) {
    const button = event.target.closest('[data-action]');

    if (!button) {
      return;
    }

    switch (button.dataset.action) {
      case 'accept':
        this.#save({ analytics: true, marketing: true, preferences: true });
        break;
      case 'decline':
        this.#save({ analytics: false, marketing: false, preferences: false });
        break;
      case 'customize':
        this.openDialog();
        break;
      case 'save': {
        const values = {};
        this.dialog.querySelectorAll('.custom-cookie__switch').forEach((input) => (values[input.name] = input.checked));
        this.#save(values);
        break;
      }
    }
  }

  #save({ analytics, marketing, preferences }) {
    const done = (response) => {
      // Luk kun, hvis Shopify faktisk har gemt valget – ellers bliver banneret stående
      if (response?.error) {
        console.warn('[Sportsact cookie-banner]', response.error);
        return;
      }

      this.banner.hidden = true;

      if (this.dialog.open) {
        this.dialog.close();
      }
    };

    if (!this.#api) {
      done();
      return;
    }

    // sale_of_data følger marketing (salg/deling af data til annoncering)
    this.#api.setTrackingConsent({ analytics, marketing, preferences, sale_of_data: marketing }, done);
  }

  // Banneret skal ligge OVER sticky "Læg i kurv"-baren på mobil og aldrig dække den
  // (og over Impacts sticky "Læg i kurv" på desktop)
  #trackStickyBarHeight() {
    if (!window.ResizeObserver) {
      return;
    }

    [
      ['custom-sticky-atc', '--custom-sticky-atc-height'],
      ['.product-quick-add', '--custom-quick-add-height']
    ].forEach(([selector, variable]) => {
      const element = document.querySelector(selector);

      if (element) {
        new ResizeObserver(() => {
          document.documentElement.style.setProperty(variable, `${element.offsetHeight}px`);
        }).observe(element);
      }
    });
  }
}

if (!window.customElements.get('custom-cookie-banner')) {
  window.customElements.define('custom-cookie-banner', CustomCookieBanner);
}
